<script>
export default {
	name: 'TDestinationDotSingleCount',
	functional: true,
	props: {
		count: {
			type: Number,
			default: 0
		}
	},
	render(_, context) {
		if (context.props.count === 0) return null;
		return (
			<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g transform="translate(-36.000000, -29.000000)">
						<g transform="translate(36.000000, 29.000000)">
							<circle fill="#e4e7eb" cx="6" cy="6" r="6"></circle>
							<text id="1" font-family="SFProText-Medium, SF Pro Text" font-size="10" font-weight="400" letter-spacing="-0.20" fill="#425A70">
								<tspan x="2.56544922" y="10">{context.props.count}</tspan>
							</text>
						</g>
					</g>
				</g>
			</svg>
		);
	}
};
</script>
